module.exports = __webpack_public_path__ + "static/media/TIGROS.c7821d63.svg";